import styled from 'styled-components';

export const SubscribeContainer = styled.div`
  background-color: #0072b5;
`;
